<template>
  <v-container class="loan-work-queue" grid-list-xl fluid ref="UI">
    <div class="queue-header-btn">
      <v-btn class="topLeft" text small @click="dialogEventHandler(assist.dataType.DialogActionEnum.DISPLAY)">Date Range
        <v-icon right>date_range</v-icon>
      </v-btn>
      <div class="dateRange" v-if="showRange">{{dateRange}}</div>
      <arb-btn-menu :position="sortByPosition" v-model="layout.sortBy" label="Sort By" @click="sortByEventHandler"></arb-btn-menu>
      <div :style="sortByStyle" v-if="showSortBy">{{sortBy}}</div>
      <span :style="languageselected.textStyle">Language:</span>
      <div v-if="languageselected.show">
      <v-select
        :style="languageselected.style"
        v-model="selectedLanguage"
        :items="languages.map(lang => lang.text)"
        class="language-dropdown"
        single-line
        @change="onLanguageSelect"
      ></v-select>
      </div>
      <div v-else>
        <span :style="languageText.style">{{ selectedLanguage }}</span>
      </div>
      <span :style="sameDayFilter.textStyle" v-if="sameDayFilter.show">Same Day ACH</span>
      <div v-if="sameDayFilter.show">
        <v-switch
          :style="sameDayFilter.style"
          v-model="sameDayFilter.isSameDay"
          @change="filterChange"
        >
        </v-switch>
      </div>
      <span :style="reapprovedFilter.textStyle" v-if="reapprovedFilter.show">Reapproved</span>
      <div v-if="reapprovedFilter.show">
        <v-switch
          :style="reapprovedFilter.style"
          v-model="reapprovedFilter.isReapproved"
          @change="filterChange"
        >
        </v-switch>
      </div>
      <span :style="defaultDisbursementModeFilter.textStyle" v-if="defaultDisbursementModeFilter.show">Instant Funding</span>
      <div v-if="defaultDisbursementModeFilter.show">
        <v-switch
          :style="defaultDisbursementModeFilter.style"
          v-model="defaultDisbursementModeFilter.isInstantFunding"
          @change="filterChange"
        >
        </v-switch>
      </div>
      <span :style="returningFilter.textStyle" v-if="returningFilter.show">Returning Customer</span>
      <div v-if="returningFilter.show">
        <v-switch
          :style="returningFilter.style"
          v-model="returningFilter.isReturning"
          @change="filterChange"
        >
        </v-switch>
      </div>
      <span :style="consultationFilter.textStyle" v-if="consultationFilter.show">Is Under Consultation</span>
      <div v-if="consultationFilter.show">
        <v-switch
          :style="consultationFilter.style"
          v-model="consultationFilter.isConsultation"
          @change="filterChange"
        >
        </v-switch>
      </div>
      <span :style="returnedFilter.textStyle" v-if="returnedFilter.show">Returned from Application Review</span>
      <div v-if="returnedFilter.show">
        <v-switch
            :style="returnedFilter.style"
            v-model="returnedFilter.isFromUw"
            @change="filterChange"
        >
        </v-switch>
      </div>
        <span :style="VIPLoanFilter.textStyle" v-if="VIPLoanFilter.show">VIP Channel</span>
      <div v-if="VIPLoanFilter.show">
        <v-switch
            :style="VIPLoanFilter.style"
            v-model="VIPLoanFilter.isVipLoan"
            @change="filterChange"
        >
        </v-switch>
      </div>
      <ul class="topRight nav-tabs">
        <li v-for="(item,index) in cardOrTable" :key="index" class="nav-item">
          <a @click="toggleCardOrTable(index)" :class="{active:chooseIndex==index || activeWorkQueue.status === assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  dark
                  v-bind="attrs"
                  v-on="on">{{ item.icon }}</v-icon>
              </template>
              <span>{{ item.text }}</span>
            </v-tooltip>
          </a>
        </li>
      </ul>
      <div class="withdrawnReason" :style="withdrawnFilter.style" v-if="withdrawnFilter.showFilter">Withdrawn Reason</div>
      <v-select
        v-if="withdrawnFilter.showFilter"
        v-model="withdrawnFilter.enum"
        :items="withdrawnFilter.items"
        item-text="text"
        item-value="value"
        persistent-hint
        return-object
        single-line
        @change="filterChange"
        :style="withdrawnFilter.selectStyle"
      ></v-select>
    </div>
    <div v-if="flag" class="queue-tab" id="eleItems">
      <template>
        <v-card class="queue-tab-card">
          <v-tabs
            v-model="tab"
            dark
            background-color="#fff"
            show-arrows
            icons-and-text
            grow
            class="loan-queue-tabs"
          >
            <v-tabs-slider :color="sliderColor"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in dataWorkQueue"
              :key="index"
              style="color:#bbb; background: #fff"
              active-class="choose"
              @click="clickItem(index)"
            >
              <div>[{{tab.count}}]</div>
              <div>{{ tab.title === 'Underwriter Review' ? 'Application Review' : tab.title }}
                <span v-if="assist.tool.isNotEmpty(tab.iconItem)">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }" v-if="isShowElement(tab.iconItem.code, assist.dataType.PrivilegeType.READABLE)">
                      <v-icon
                        :color="tab.color[0]"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="clickBtnHandler(tab.status)">{{ tab.iconItem.icon }}</v-icon>
                    </template>
                    <span>{{ tab.iconItem.tooltip }}</span>
                  </v-tooltip>
                </span>
              </div>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item
              v-for="(tab, index) in dataWorkQueue"
              :key="index"
            >
              <v-progress-linear
                v-if="tab.isLoading"
                :color="tab.color[0]"
                indeterminate
                rounded
              ></v-progress-linear>
                <div v-if="isShowBtn()" style="text-align: right;">
                  <div v-if="tab.title === 'Suspected Litigant'">
                    <v-btn
                      :color="'primary'"
                      @click="clickProcessBtn(index)"
                      >
                      Process All
                    </v-btn>
                  </div>
                </div>
                <div v-if="isShowBtn()" style="text-align: right;">
                  <div v-if="tab.title === 'Tribe NOAA Review'">
                    <v-btn
                       color="error"
                      @click="clickDenyAll(index)"
                      >
                      Deny All
                    </v-btn>
                  </div>
                </div>
              <v-card flat>
                <div class="queue-content-table" v-if="tab.status === assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value">
                  <v-data-table
                    :headers="runtimeHeader"
                    :items="tableData"
                    :items-per-page="10"
                    class="elevation-1"
                    style="margin: 10px;"
                    fixed-header
                    :options.sync="options"
                    :server-items-length="options.pageCount"
                    :footer-props="footerProps"
                  >
                    <template v-slot:item="props">
                      <tr v-if="props.item.locked_by === '—'" style="color: #3F4360" :style="getTableBackgroundColor(props.item)">
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index === 0;
                            }
                          )"
                          :key="headerData.value"
                          class="loanFirst"
                        >
                          <div :style="{background: tab.color[0]}" class="tableShow"></div>
                          <div class="tableLoanDetails">
                            <div class="tableLoanNo">{{props.item[headerData.value].loanNo}}</div>
                            <div style="margin-top: 8px;">
                              <span class="tableName">{{props.item[headerData.value].name}}</span>
                              <span class="tableRequestedAmount">{{props.item[headerData.value].requested_amount}}</span>
                            </div>
                          </div>
                        </td>
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index === 1;
                            }
                          )"
                          :key="headerData.value"
                        >
                          <v-btn
                            :color="tab.color[0]"
                            small
                            @click="gotoDetail(props.item)"
                            class="detailBtn"
                            tile
                          >
                           Detail
                          </v-btn>
                        </td>
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index === 2;
                            }
                          )"
                          :key="headerData.value"
                        >
                          <span v-if="(isLos(props.item) && (props.item[headerData.value][0].display || props.item[headerData.value][1].display || props.item[headerData.value][2].display)) || (props.item[headerData.value][3].display || props.item[headerData.value][4].display) || (props.item[headerData.value][5].display)" class="text-right">
                            <span v-if="props.item[headerData.value][0].display
                            || (props.item[headerData.value][1].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.RETURNING_QUEUE))
                            || (props.item[headerData.value][2].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.UNDERWRITER_REVIEW_QUEUE))
                            || (props.item[headerData.value][3].display)
                            || (props.item[headerData.value][4].display)
                            || (props.item[headerData.value][5].display)">
                              <v-tooltip bottom v-if="props.item[headerData.value][0].display">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    x-small
                                    slot="activator"
                                    v-on="on"
                                  >
                                    <i class="fab fa-hotjar" style="color: #D32F2F !important;"></i>
                                  </v-btn>
                                </template>
                                <span>Same Day</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][1].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.RETURNING_QUEUE)">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    x-small
                                    slot="activator"
                                    v-on="on"
                                  >
                                    <span class="material-icons" :style="props.item[headerData.value][1].color">{{ props.item[headerData.value][1].style }}</span>
                                  </v-btn>
                                </template>
                                <span>{{ props.item[headerData.value][1].title }}</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][2].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.UNDERWRITER_REVIEW_QUEUE)">
                                <template v-slot:activator="{ on }">
                                  <v-icon style="cursor: pointer;" color="orange" small slot="activator" v-on="on">published_with_changes</v-icon>
                                </template>
                                <span>Re-Sent to UW</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][3].display ">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    x-small
                                    slot="activator"
                                    v-on="on"
                                  >
                                    <span class="material-icons" style="color: #D32F2F !important;">credit_card</span>
                                  </v-btn>
                                </template>
                                <span>Credit Card</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][4].display ">
                                <template v-slot:activator="{ on, attrs }">
                                   <v-btn  icon
                                           x-small
                                           slot="activator"
                                           class="action-button"
                                           v-on="on"
                                           v-bind="attrs"
                                           width="27px"
                                   >
                                    <span class="material-icons" style="color: #d32f2f !important;">compress</span>
                                   </v-btn>
                                </template>
                                <span>compress</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][5].display">
                                <template v-slot:activator="{ on, attrs }">
                                   <v-btn  icon
                                           x-small
                                           slot="activator"
                                           class="action-button"
                                           v-on="on"
                                           v-bind="attrs"
                                           width="27px"
                                   >
                                    <span class="material-icons" style="color: #d32f2f !important;">support</span>
                                   </v-btn>
                                </template>
                                <span>Fox Express</span>
                              </v-tooltip>
                            </span>
                            <span v-else>—</span>
                          </span>
                          <span v-else>{{ props.item[headerData.value][1].title }}</span>
                        </td>
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index !== 0 && index !== 1 && index !== 2;
                            }
                          )"
                          :key="headerData.value"
                        >
                          {{props.item[headerData.value]}}
                        </td>
                      </tr>
                      <tr v-else style="color: #C4C7D8" :style="getTableBackgroundColor(props.item)">
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index === 0;
                            }
                          )"
                          :key="headerData.value"
                        >
                          <div style="background: #C4C7D8" class="tableShow"></div>
                          <div class="tableLoanDetails">
                            <div class="tableLoanNo" style="color: #7E829B; font-weight: normal">{{props.item[headerData.value].loanNo}}
                              <img :src="computeLogo" height="24" class="locked-icon"/>
                            </div>
                            <div style="margin-top: 8px;">
                              <span class="tableName" style="color: #7E829B">{{props.item[headerData.value].name}}</span>
                              <span class="tableRequestedAmount" style="color: #7E829B">{{props.item[headerData.value].requested_amount}}</span>
                            </div>
                          </div>
                        </td>
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index === 1;
                            }
                          )"
                          :key="headerData.value"
                        >
                          <v-btn
                            :color="tab.color[1]"
                            small
                            @click="gotoDetail(props.item)"
                            class="detailBtn"
                            :style="{color: tab.color[0]}"
                            tile
                          >
                           Detail
                          </v-btn>
                        </td>
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index === 2;
                            }
                          )"
                          :key="headerData.value"
                        >
                          <span v-if="(isLos(props.item) && (props.item[headerData.value][0].display || props.item[headerData.value][1].display || props.item[headerData.value][2].display)) || props.item[headerData.value][3].display || props.item[headerData.value][4].display || (props.item[headerData.value][5].display)" class="text-right">
                            <span v-if="props.item[headerData.value][0].display
                            || (props.item[headerData.value][1].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.RETURNING_QUEUE))
                            || (props.item[headerData.value][2].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.UNDERWRITER_REVIEW_QUEUE))
                            || (props.item[headerData.value][3].display)
                            || (props.item[headerData.value][4].display)
                            || (props.item[headerData.value][5].display)">
                              <v-tooltip bottom v-if="props.item[headerData.value][0].display">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    x-small
                                    slot="activator"
                                    v-on="on"
                                  >
                                    <i class="fab fa-hotjar" style="color: #D32F2F !important;"></i>
                                  </v-btn>
                                </template>
                                <span>Same Day</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][1].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.RETURNING_QUEUE)">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    x-small
                                    slot="activator"
                                    v-on="on"
                                  >
                                    <span class="material-icons" :style="props.item[headerData.value][1].color">{{ props.item[headerData.value][1].style }}</span>
                                  </v-btn>
                                </template>
                                <span>{{ props.item[headerData.value][1].title }}</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][2].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.UNDERWRITER_REVIEW_QUEUE)">
                                <template v-slot:activator="{ on }">
                                  <v-icon style="cursor: pointer;" color="orange" small slot="activator" v-on="on">published_with_changes</v-icon>
                                </template>
                                <span>Re-Sent to UW</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][3].display ">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    x-small
                                    slot="activator"
                                    v-on="on"
                                  >
                                    <span class="material-icons" style="color: #D32F2F !important;">credit_card</span>
                                  </v-btn>
                                </template>
                                <span>Credit Card</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][4].display ">
                                <template v-slot:activator="{ on, attrs }">
                                   <v-btn  icon
                                      x-small
                                      slot="activator"
                                      class="action-button"
                                      v-on="on"
                                      v-bind="attrs"
                                      width="27px"
                                      >
                                    <span class="material-icons" style="color: #d32f2f !important;">compress</span>
                                   </v-btn>
                                </template>
                                <span>compress</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][5].display">
                                <template v-slot:activator="{ on, attrs }">
                                   <v-btn  icon
                                           x-small
                                           slot="activator"
                                           class="action-button"
                                           v-on="on"
                                           v-bind="attrs"
                                           width="27px"
                                   >
                                    <span class="material-icons" style="color: #d32f2f !important;">support</span>
                                   </v-btn>
                                </template>
                                <span>Fox Express</span>
                              </v-tooltip>
                            </span>
                            <span v-else>—</span>
                          </span>
                          <span v-else>{{ props.item[headerData.value][1].title }}</span>
                        </td>
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index !== 0 && index !== 1 && index !== 2;
                            }
                          )"
                          :key="headerData.value"
                        >
                          {{props.item[headerData.value]}}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
                <div class="queue-content" v-else>
                  <div class="scroll" @scroll="scrollEvent" @mouseover="mouseOver($event)" @mouseleave="mouseLeave($event)">
                    <waterfall :col="cloNumbers" :data="assist.tool.isEmpty(tab.items) ? [] : tab.items">
                      <template v-for="(item, index) in tab.items">
                        <arb-application-queue-item
                          :key="index"
                          :itemData="item"
                          :layoutSetting="layout.setting.item"
                          :loanPhase="loanPhase"
                          :color="tab.color[0]"
                          :secondColor="tab.color[1]"
                          class="item-card"
                          :queueCode="tab.code"
                          :privileges="authorization.privileges"
                          :roleList="roleList"
                        ></arb-application-queue-item>
                      </template>
                    </waterfall>
                  </div>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </template>
    </div>
    <div v-else>
      <template>
        <v-card class="queue-tab-card">
          <v-tabs
            v-model="tab"
            dark
            background-color="#fff"
            show-arrows
            icons-and-text
            grow
          >
            <v-tabs-slider :color="sliderColor"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in dataWorkQueueTable"
              :key="index"
              style="color:#bbb; background: #fff"
              active-class="choose"
              @click="clickItem(index)"
            >
              <div>[{{tab.count}}]</div>
              <div>{{ tab.title === 'Underwriter Review' ? 'Application Review' : tab.title }}
                <span v-if="assist.tool.isNotEmpty(tab.iconItem)">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        :color="tab.color[0]"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="clickBtnHandler(tab.status)">{{ tab.iconItem.icon }}</v-icon>
                    </template>
                    <span>{{ tab.iconItem.tooltip }}</span>
                  </v-tooltip>
                </span>
              </div>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item
              v-for="(tab, index) in dataWorkQueueTable"
              :key="index"
            >
              <v-progress-linear
                v-if="tab.isLoading"
                :color="tab.color[0]"
                indeterminate
                rounded
              ></v-progress-linear>
              <v-card flat>
                <div v-if="isShowBtn()" style="text-align: right;">
                  <div v-if="tab.title === 'Tribe NOAA Review'">
                    <v-btn
                       color="error"
                      @click="clickDenyAll(index)"
                      >
                      Deny All
                    </v-btn>
                  </div>
                </div>
                <div class="queue-content-table">
                  <v-data-table
                    :headers="runtimeHeader"
                    :items="tableData"
                    :items-per-page="10"
                    class="elevation-1"
                    style="margin: 10px;"
                    fixed-header
                    :options.sync="options"
                    :server-items-length="options.pageCount"
                    :footer-props="footerProps"
                  >
                    <template v-slot:item="props">
                      <tr v-if="props.item.locked_by === '—'" style="color: #3F4360" :style="getTableBackgroundColor(props.item)">
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index === 0;
                            }
                          )"
                          :key="headerData.value"
                          class="loanFirst"
                        >
                          <div :style="{background: tab.color[0]}" class="tableShow"></div>
                          <div class="tableLoanDetails">
                            <div class="tableLoanNo">{{props.item[headerData.value].loanNo}}</div>
                            <div style="margin-top: 8px;">
                              <span class="tableName">{{props.item[headerData.value].name}}</span>
                              <span class="tableRequestedAmount">{{props.item[headerData.value].requested_amount}}</span>
                            </div>
                          </div>
                        </td>
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index === 1;
                            }
                          )"
                          :key="headerData.value"
                        >
                          <v-btn
                            :color="tab.color[0]"
                            small
                            @click="gotoDetail(props.item)"
                            class="detailBtn"
                            tile
                          >
                           Detail
                          </v-btn>
                        </td>
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index === 2;
                            }
                          )"
                          :key="headerData.value"
                        >
                          <span v-if="(isLos(props.item) && (props.item[headerData.value][0].display || props.item[headerData.value][1].display || props.item[headerData.value][2].display)) || (props.item[headerData.value][3].display || props.item[headerData.value][4].display) || (props.item[headerData.value][5].display)" class="text-right">
                            <span v-if="props.item[headerData.value][0].display
                            || (props.item[headerData.value][1].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.RETURNING_QUEUE))
                            || (props.item[headerData.value][2].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.UNDERWRITER_REVIEW_QUEUE))
                            || (props.item[headerData.value][3].display)
                            || (props.item[headerData.value][4].display)
                            || (props.item[headerData.value][5].display)">
                              <v-tooltip bottom v-if="props.item[headerData.value][0].display">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    x-small
                                    slot="activator"
                                    v-on="on"
                                  >
                                    <i class="fab fa-hotjar" style="color: #D32F2F !important;"></i>
                                  </v-btn>
                                </template>
                                <span>Same Day</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][1].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.RETURNING_QUEUE)">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    x-small
                                    slot="activator"
                                    v-on="on"
                                  >
                                    <span class="material-icons" :style="props.item[headerData.value][1].color">{{ props.item[headerData.value][1].style }}</span>
                                  </v-btn>
                                </template>
                                <span>{{ props.item[headerData.value][1].title }}</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][2].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.UNDERWRITER_REVIEW_QUEUE)">
                                <template v-slot:activator="{ on }">
                                  <v-icon style="cursor: pointer;" color="orange" small slot="activator" v-on="on">published_with_changes</v-icon>
                                </template>
                                <span>Re-Sent to UW</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][3].display ">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    x-small
                                    slot="activator"
                                    v-on="on"
                                  >
                                    <span class="material-icons" style="color: #D32F2F !important;">credit_card</span>
                                  </v-btn>
                                </template>
                                <span>Credit Card</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][4].display ">
                                <template v-slot:activator="{ on, attrs }">
                                   <v-btn  icon
                                           x-small
                                           slot="activator"
                                           class="action-button"
                                           v-on="on"
                                           v-bind="attrs"
                                           width="27px"
                                   >
                                    <span class="material-icons" style="color: #d32f2f !important;">compress</span>
                                   </v-btn>
                                </template>
                                <span>compress</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][5].display">
                                <template v-slot:activator="{ on, attrs }">
                                   <v-btn  icon
                                           x-small
                                           slot="activator"
                                           class="action-button"
                                           v-on="on"
                                           v-bind="attrs"
                                           width="27px"
                                   >
                                    <span class="material-icons" style="color: #d32f2f !important;">support</span>
                                   </v-btn>
                                </template>
                                <span>Fox Express</span>
                              </v-tooltip>
                            </span>
                            <span v-else>—</span>
                          </span>
                          <span v-else>{{ props.item[headerData.value][1].title }}</span>
                        </td>
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index !== 0 && index !== 1 && index !== 2;
                            }
                          )"
                          :key="headerData.value"
                        >
                          {{props.item[headerData.value]}}
                        </td>
                      </tr>
                      <tr v-else style="color: #C4C7D8" :style="getTableBackgroundColor(props.item)">
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index === 0;
                            }
                          )"
                          :key="headerData.value"
                        >
                          <div style="background: #C4C7D8" class="tableShow"></div>
                          <div class="tableLoanDetails">
                            <div class="tableLoanNo" style="color: #7E829B; font-weight: normal">{{props.item[headerData.value].loanNo}}
                              <img :src="computeLogo" height="24" class="locked-icon"/>
                            </div>
                            <div style="margin-top: 8px;">
                              <span class="tableName" style="color: #7E829B">{{props.item[headerData.value].name}}</span>
                              <span class="tableRequestedAmount" style="color: #7E829B">{{props.item[headerData.value].requested_amount}}</span>
                            </div>
                          </div>
                        </td>
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index === 1;
                            }
                          )"
                          :key="headerData.value"
                        >
                          <v-btn
                            :color="tab.color[1]"
                            small
                            @click="gotoDetail(props.item)"
                            class="detailBtn"
                            :style="{color: tab.color[0]}"
                            tile
                          >
                           Detail
                          </v-btn>
                        </td>
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index === 2;
                            }
                          )"
                          :key="headerData.value"
                        >
                          <span v-if="(isLos(props.item) && (props.item[headerData.value][0].display || props.item[headerData.value][1].display || props.item[headerData.value][2].display)) || props.item[headerData.value][3].display || props.item[headerData.value][4].display || (props.item[headerData.value][5].display)" class="text-right">
                            <span v-if="props.item[headerData.value][0].display
                            || (props.item[headerData.value][1].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.RETURNING_QUEUE))
                            || (props.item[headerData.value][2].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.UNDERWRITER_REVIEW_QUEUE))
                            || (props.item[headerData.value][3].display)
                            || (props.item[headerData.value][4].display)
                            || (props.item[headerData.value][5].display)">
                              <v-tooltip bottom v-if="props.item[headerData.value][0].display">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    x-small
                                    slot="activator"
                                    v-on="on"
                                  >
                                    <i class="fab fa-hotjar" style="color: #D32F2F !important;"></i>
                                  </v-btn>
                                </template>
                                <span>Same Day</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][1].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.RETURNING_QUEUE)">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    x-small
                                    slot="activator"
                                    v-on="on"
                                  >
                                    <span class="material-icons" :style="props.item[headerData.value][1].color">{{ props.item[headerData.value][1].style }}</span>
                                  </v-btn>
                                </template>
                                <span>{{ props.item[headerData.value][1].title }}</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][2].display && isDisplayIcon(tab.code, assist.dataType.PrivilegeCode.UNDERWRITER_REVIEW_QUEUE)">
                                <template v-slot:activator="{ on }">
                                  <v-icon style="cursor: pointer;" color="orange" small slot="activator" v-on="on">published_with_changes</v-icon>
                                </template>
                                <span>Re-Sent to UW</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][3].display ">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    x-small
                                    slot="activator"
                                    v-on="on"
                                  >
                                    <span class="material-icons" style="color: #D32F2F !important;">credit_card</span>
                                  </v-btn>
                                </template>
                                <span>Credit Card</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][4].display ">
                                <template v-slot:activator="{ on, attrs }">
                                   <v-btn  icon
                                      x-small
                                      slot="activator"
                                      class="action-button"
                                      v-on="on"
                                      v-bind="attrs"
                                      width="27px"
                                      >
                                    <span class="material-icons" style="color: #d32f2f !important;">compress</span>
                                   </v-btn>
                                </template>
                                <span>compress</span>
                              </v-tooltip>
                              <v-tooltip bottom v-if="props.item[headerData.value][5].display">
                                <template v-slot:activator="{ on, attrs }">
                                   <v-btn  icon
                                           x-small
                                           slot="activator"
                                           class="action-button"
                                           v-on="on"
                                           v-bind="attrs"
                                           width="27px"
                                   >
                                    <span class="material-icons" style="color: #d32f2f !important;">support</span>
                                   </v-btn>
                                </template>
                                <span>Fox Express</span>
                              </v-tooltip>
                            </span>
                            <span v-else>—</span>
                          </span>
                          <span v-else>{{ props.item[headerData.value][1].title }}</span>
                        </td>
                        <td
                          v-for="headerData in runtimeHeader.filter(
                            (val, index, arr) => {
                              return index !== 0 && index !== 1 && index !== 2;
                            }
                          )"
                          :key="headerData.value"
                        >
                          {{props.item[headerData.value]}}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </template>
    </div>
    <v-dialog max-width="800px" v-model="layoutData.dialog.display" persistent>
      <arb-date-range-card
        v-if="layoutData.dialog.display"
        v-model="layoutData.dialog.data"
        :eventHandler="dialogEventHandler"
        @showDateRange="showDateRange"
      ></arb-date-range-card>
    </v-dialog>
    <v-dialog max-width="900px" v-model="batchApproveDialog" persistent>
      <batch-approve-dialog
        :beginDate="layoutData.dialog.data.startDate"
        :endDate="layoutData.dialog.data.endDate"
        :display="batchApproveDialog"
        @hideDialog="hideDialogHandler"
      ></batch-approve-dialog>
    </v-dialog>
    <v-dialog max-width="900px" v-model="exportPaidOffDialog.display" persistent>
      <export-paid-off-dialog
        :beginDate="layoutData.dialog.data.startDate"
        :endDate="layoutData.dialog.data.endDate"
        :loanStatus="exportPaidOffDialog.loanStatus"
        :display="exportPaidOffDialog.display"
        :loanPhase="loanPhase"
        @hideDialog="hideExportPaidOffDialogHandler"
      ></export-paid-off-dialog>
    </v-dialog>
    <v-dialog max-width="900px" v-model="exportUnderWriterDialog.display" persistent>
      <export-underWriter-dialog
        :beginDate="layoutData.dialog.data.startDate"
        :endDate="layoutData.dialog.data.endDate"
        :loanStatus="exportUnderWriterDialog.loanStatus"
        :display="exportUnderWriterDialog.display"
        @hideDialog="hideExportUnderWriterDialogHandler"
      ></export-underWriter-dialog>
    </v-dialog>
  </v-container>
</template>

<script>
import { Authentication, Tool, DataType, MyDebounce, Crypto, Cache, Popup } from '@/util/index'
import { LoanResourceApi, CollectionApi, ProcessingApi, OAuthApi, OriginationBusinessApi } from '@/api/pandaria'
import BatchApproveDialog from '../../pre-origination/dialog/BatchApproveDialog'
import { SystemEnum } from '@/assets/js'
import ExportPaidOffDialog from '@/components/panda/post-origination/dialog/ExportPaidOffDialog'
import locked from '@/assets/images/icon_lock.png'
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'
import ExportUnderWriterDialog from '../../pre-origination/dialog/ExportUnderWriterDialog'
import _ from 'lodash'

const $tool = new Tool()
const $debounce = new MyDebounce()
const cache = new Cache()
const popup = new Popup()

export default {
  name: 'loan-work-queue-card',
  components: {
    ExportPaidOffDialog,
    BatchApproveDialog,
    ExportUnderWriterDialog
  },
  props: {
    layout: {
      type: Object,
      default: () => {
        return {
          sortBy: [],
          setting: {}
        }
      }
    },
    loanPhase: {
      type: Number
    },
    queueType: {
      type: Number
    },
    isOverflowQueue: {
      type: Boolean,
      require: false,
      default: false
    },
    headers: {
      type: Array,
      default: () => LIST_TABLE_HEADER.WORK_QUEUE_TABLE_HEADERS
    }
  },
  data () {
    return {
      selectedLanguage: '',
      languages: DataType.LanguageConst,
      languageEnum: DataType.Languages,
      account: {},
      assist: {
        tool: $tool,
        dataType: DataType
      },
      layoutData: {
        workQueue: this.layout.setting.workQueue,
        dialog: {
          display: false,
          data: {
            startDate: '',
            endDate: ''
          }
        },
        fullWindowWidth: document.body.clientWidth,
        sortBy: null
      },
      batchApproveDialog: false,
      exportPaidOffDialog: {
        display: false,
        loanStatus: ''
      },
      exportUnderWriterDialog: {
        display: false,
        loanStatus: ''
      },
      tab: null,
      cloNumbers: 5,
      showRange: false,
      dateRange: '',
      sortByPosition: 'toLeft',
      sliderColor: '',
      showSortBy: false,
      sortBy: '',
      sortByStyle: 'position: absolute; left: 255px; top: 15px;',
      languageStyle: 'position: absolute; left: 255px; top: 15px height: 27px;',
      clickItemIndex: 0,
      clickItemIndexTable: 0,
      debounce: $debounce,
      dataWorkQueue: [],
      dataWorkQueueTable: [],
      cardOrTable: [
        { text: 'Card View', icon: 'dashboard' },
        { text: 'Table View', icon: 'table_chart' }
      ],
      chooseIndex: 0,
      /**
       * card or table
       * true -> card; false -> table
       */
      flag: true,
      tableData: [],
      options: {
        page: 1,
        itemsPerPage: 10,
        pageCount: 0
      },
      footerProps: {
        'items-per-page-options': [10, 20, 50]
      },
      pagination: {
        index: 1,
        size: 10,
        orderBy: null
      },
      losWorkQueueLoanStatus: [
        DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.CORRECTOR_REVIEW.value, DataType.LoanStatus.UNDERWRITER_REVIEW.value, DataType.LoanStatus.TRIBE_REVIEW.value,
        DataType.LoanStatus.POSITIVE_WITHDRAWN.value, DataType.LoanStatus.NEGATIVE_WITHDRAWN.value
      ],
      thColor: '',
      tabColor: '',
      authorization: {},
      isShowOperatedBy: false,
      roleList: [],
      withdrawnFilter: {
        showFilter: false,
        enum: null,
        items: [],
        style: 'position: absolute; left: 650px; top: 15px;',
        selectStyle: 'position: absolute; left: 800px; top: -10px; width: 12%;'
      },
      sameDayFilter: {
        show: false,
        isSameDay: false,
        style: 'position: absolute; left: 620px; top: -5px;',
        textStyle: 'position: absolute; left: 510px; top: 17px;'
      },
      languageselected: {
        show: false,
        selectedLanguage: this.selectedLanguage,
        style: 'position: absolute; left: 358px; top: -5px; width: 152px;',
        textStyle: 'position: absolute; left: 280px; top: 17px;'
      },
      languageText: {
        style: 'position: absolute; left: 360px; top: 17px;',
        selectedLanguage: this.selectedLanguage
      },
      reapprovedFilter: {
        show: false,
        isReapproved: false,
        style: 'position: absolute; left: 765px; top: -5px;',
        textStyle: 'position: absolute; left: 670px; top: 17px;'
      },
      returningFilter: {
        show: false,
        isReturning: false,
        style: 'position: absolute; left: 1137px; top: -5px;',
        textStyle: 'position: absolute; left: 985px; top: 17px;'
      },
      consultationFilter: {
        show: false,
        isConsultation: false,
        style: 'position: absolute; left: 1347px; top :-5px;',
        textStyle: 'position: absolute; left: 1185px; top: 17px;'
      },
      returnedFilter: {
        show: false,
        isFromUw: false,
        style: 'position: absolute; left: 908px; top :-5px;',
        textStyle: 'position: absolute; left: 650px; top: 17px;'
      },
      VIPLoanFilter: {
        show: false,
        isVipLoan: false,
        style: 'position: absolute; left: 1045px; top :-5px;',
        textStyle: 'position: absolute; left: 950px; top: 17px;'
      },
      defaultDisbursementModeFilter: {
        show: false,
        isInstantFunding: false,
        style: 'position: absolute; left: 935px; top: -5px;',
        textStyle: 'position: absolute; left: 815px; top: 17px;'
      },
      runtimeHeader: LIST_TABLE_HEADER.WORK_QUEUE_TABLE_HEADERS,
      activeWorkQueue: {
        status: SystemEnum.WORK_QUEUE_ENUM.AGENT_REVIEW.value,
        title: SystemEnum.WORK_QUEUE_ENUM.AGENT_REVIEW.text,
        key: SystemEnum.WORK_QUEUE_ENUM.AGENT_REVIEW.key,
        features: SystemEnum.WORK_QUEUE_ENUM.AGENT_REVIEW.features,
        color: ['#5C82E3', '#F2F5FD'],
        code: DataType.PrivilegeCode.AGENT_REVIEW_QUEUE,
        count: 0,
        items: [],
        indexOfPage: 1,
        isEnd: true,
        isLoading: true
      }
    }
  },
  watch: {
    isInitQueue (val) {
      if (val) {
        this.initQueueData(this.clickItemIndex)
      }
    },
    'store.getters.getRoleCode': function () {
      if (this.loanPhase === DataType.LoanPhaseEnum.LOAN_COLLECTION.value) {
        this.initQueueData(this.clickItemIndex)
      }
    },
    '$store.getters.getRuntimePortfolio': {
      handler: function (newVal, oldVal) {
        if ($tool.compareTwoPortfolioArray(newVal, oldVal)) {
          this.initQueueData(this.clickItemIndex)
        }
      }
    },
    'options.page': {
      handler (val) {
        if (val < this.pagination.index) {
          this.pagination.index = val
          this.pagination.size = this.options.itemsPerPage
          this.changePageQueueDataTable(this.clickItemIndexTable, 'sub')
        } else if (val > this.pagination.index) {
          this.pagination.index = val
          this.pagination.size = this.options.itemsPerPage
          this.changePageQueueDataTable(this.clickItemIndexTable, 'add')
        }
      }
    },
    'options.itemsPerPage': {
      handler (val) {
        this.pagination.index = this.options.page
        this.pagination.size = val
        this.initQueueDataTable(this.clickItemIndexTable)
      }
    },
    thColor (val) {
      this.$refs.UI.style.setProperty('--thColor', val)
    },
    tabColor (val) {
      this.$refs.UI.style.setProperty('--tabColor', val)
    },
    'store.getters.getAuthorization': {
      handler: async function (val) {
        this.authorization = val
        this.isShowOperatedBy = Authentication.matchElementPrivilege(val.privileges, DataType.PrivilegeCode.SHOW_OPERATED_BY, DataType.PrivilegeType.EXECUTABLE)
        if (!this.isShowOperatedBy) {
          await this.listRole()
        }
        this.$forceUpdate()
      }
    },
    activeWorkQueue: {
      handler (val) {
        if (val && val?.status === this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
          this.cardOrTable = [
            { text: 'Table View', icon: 'table_chart' }
          ]
        } else {
          this.cardOrTable = [
            { text: 'Card View', icon: 'dashboard' },
            { text: 'Table View', icon: 'table_chart' }
          ]
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    isInitQueue () {
      return $tool.isNotEmpty(this.store.getters.getAccount) && $tool.isNotEmpty(this.store.getters.getAuthorization)
    },
    computeLogo () {
      return locked
    }
  },
  async mounted () {
    await this.$store.dispatch('loadAccountData')
    this.account = this.store.getters.getAccount
    if (this.account.languagePreference === this.languages[0].value) {
      this.languageselected.show = true
      this.selectedLanguage = this.languages[0].text
    } else {
      this.languageselected.show = false
      const languageOption = this.languages.find(lang => lang.value === this.account.languagePreference)
      this.selectedLanguage = languageOption ? languageOption.text : 'unknown language'
    }
    this.$eventBus.$on('batchApproveHandler', target => {
      this.batchApproveDialog = true
    })
    this.$eventBus.$on('exportPaidOffHandler', target => {
      this.exportPaidOffDialog.display = true
      this.exportPaidOffDialog.loanStatus = target
    })
    this.$eventBus.$on('exportUnderWriterHandler', target => {
      this.exportUnderWriterDialog.display = true
      this.exportUnderWriterDialog.loanStatus = target
    })
    this.$eventBus.$on('initWorkQueue', target => {
      this.initQueueData(this.clickItemIndex)
    })
    this.$eventBus.$on('side-icon-click', target => {
      window.onresize = () => {
        return (() => {
          this.layoutData.fullWindowWidth = document.body.clientWidth
        })()
      }
    })

    this.sliderColor = this.layoutData.workQueue[this.clickItemIndex].color[0]
    this.thColor = this.layoutData.workQueue[this.clickItemIndex].color[0]
    this.tabColor = this.layoutData.workQueue[this.clickItemIndex].color[1]
    if (this.isInitQueue) {
      this.initQueueData(this.clickItemIndex)
    }
    if ($tool.isNotEmpty(this.$store.getters.getAuthorization)) {
      this.authorization = this.$store.getters.getAuthorization
      this.isShowOperatedBy = Authentication.matchElementPrivilege(this.authorization.privileges, DataType.PrivilegeCode.SHOW_OPERATED_BY, DataType.PrivilegeType.EXECUTABLE)
      if (!this.isShowOperatedBy) {
        await this.listRole()
      }
    }
  },
  destroyed () {
    this.clearWorkQueue()
  },
  methods: {
    async listRole () {
      const $this = this
      $this.roleList = []
      await OAuthApi.listRole(function (result) {
        for (let item of result) {
          if (typeof item === 'string') {
            item = JSON.parse(item)
          }
          $this.roleList.push(item)
        }
      })
    },
    setUI () {
      this.$refs.UI.style.setProperty('--thColor', this.thColor)
      this.$refs.UI.style.setProperty('--tabColor', this.tabColor)
    },
    isLos (itemData) {
      return this.losWorkQueueLoanStatus.includes(itemData.loanStatus)
    },
    isDisplayIcon (queueCode, privilegeCode) {
      return queueCode === privilegeCode
    },
    isShowBtn () {
      const roleCode = this.store.getters.getRoleCode
      const RoleEnum = [DataType.RoleEnum.ADMINISTRATOR.code, DataType.RoleEnum.TRIBE_QUALITY_ASSURANCE.code, DataType.RoleEnum.TRIBE_AGENT.code, DataType.RoleEnum.TRIBE_SUPERVISOR.code]
      return RoleEnum.includes(roleCode)
    },
    gotoDetail (data) {
      if ($tool.isNotEmpty(data)) {
        this.$eventBus.$emit('side-icon-click')
        this.$store.commit('setLockReason', DataType.LockLoanReasonEnum.AUTOMATIC_LOCK.value)
        this.pushPath(this.layout.setting.item.name, Crypto.encrypt(data.id))
      }
    },
    pushPath (sectionName, id) {
      if (this.loanPhase === DataType.LoanPhaseEnum.LOAN_ORIGINATION.value) {
        cache.setSessionLoanId(id)
        this.$router.push('/{0}/application'.format(sectionName))
      } else {
        this.$router.push('/{0}/application/{1}'.format(sectionName, id))
        cache.removeSessionLoanId()
      }
    },
    toggleCardOrTable (index) {
      this.chooseIndex = index
      if (index === 0 && this.activeWorkQueue.status !== this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        this.flag = true
        this.clickItemIndex = this.clickItemIndexTable
        this.initQueueData(this.clickItemIndex)
      } else if (index === 0 && this.activeWorkQueue.status === this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        this.flag = true
        this.pagination.index = 1
        this.options.page = 1
        this.options.pageCount = 0
        this.clickItemIndexTable = this.clickItemIndex
        this.initQueueDataTable(this.clickItemIndexTable)
        this.sliderColor = this.dataWorkQueue[this.clickItemIndexTable].color[0]
        this.thColor = this.dataWorkQueue[this.clickItemIndexTable].color[0]
        this.tabColor = this.dataWorkQueue[this.clickItemIndexTable].color[1]
        this.setUI()
      } else if (index === 1) {
        this.pagination.index = 1
        this.options.page = 1
        this.options.pageCount = 0
        this.flag = false
        this.clickItemIndexTable = this.clickItemIndex
        this.initQueueDataTable(this.clickItemIndexTable)
        this.sliderColor = this.dataWorkQueue[this.clickItemIndexTable].color[0]
        this.thColor = this.dataWorkQueue[this.clickItemIndexTable].color[0]
        this.tabColor = this.dataWorkQueue[this.clickItemIndexTable].color[1]
        this.setUI()
      }
      if (this.activeWorkQueue.status === this.assist.dataType.LoanStatus.AGENT_REVIEW.value) {
        this.clickItem(0)
      }
    },
    mouseOver ($event) {
      $event.currentTarget.className = 'active'
    },
    mouseLeave ($event) {
      $event.currentTarget.className = 'scroll'
    },
    scrollEvent (e) {
      if (Math.ceil(e.srcElement.scrollTop) + e.srcElement.clientHeight === e.srcElement.scrollHeight) {
        this.scrollHandler(this.dataWorkQueue[this.clickItemIndex], this.clickItemIndex)
      }
    },
    initWithdrawnFilter (loanStatus) {
      this.withdrawnFilter.items = []
      this.withdrawnFilter.enum = null
      const $this = this
      $this.WithdrawnReasonEnum = []
      OriginationBusinessApi.getWithReasonData(function (result) {
        if (loanStatus[0] === DataType.LoanStatus.POSITIVE_WITHDRAWN.value || loanStatus[0] === DataType.LoanStatus.NEGATIVE_WITHDRAWN.value) {
          $this.withdrawnFilter.showFilter = true
          if (loanStatus[0] === DataType.LoanStatus.POSITIVE_WITHDRAWN.value) {
            $this.withdrawnFilter.items = (result.POSITIVE)
          } else if (loanStatus[0] === DataType.LoanStatus.NEGATIVE_WITHDRAWN.value) {
            $this.withdrawnFilter.items = result.NEGATIVE
          }
        } else {
          $this.withdrawnFilter.showFilter = false
        }
      })
    },
    initUnderwriterFilter (loanStatus) {
      this.sameDayFilter.show = loanStatus[0] === DataType.LoanStatus.UNDERWRITER_REVIEW.value
      this.reapprovedFilter.show = loanStatus[0] === DataType.LoanStatus.UNDERWRITER_REVIEW.value
      this.returningFilter.show = loanStatus[0] === DataType.LoanStatus.UNDERWRITER_REVIEW.value
      this.consultationFilter.show = loanStatus[0] === DataType.LoanStatus.UNDERWRITER_REVIEW.value
      this.defaultDisbursementModeFilter.show = loanStatus[0] === DataType.LoanStatus.UNDERWRITER_REVIEW.value
      if (loanStatus[0] === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        this.options.itemsPerPage = 50
      } else {
        this.options.itemsPerPage = 10
      }
    },
    initAgentFilter (loanType) {
      const account = this.$store.getters.getAccount
      const isValidLoanType = [DataType.LoanStatus.AGENT_REVIEW.text, DataType.LoanStatus.CORRECTOR_REVIEW.text].includes(loanType)
      const isValidVipSettings = [0, 1].includes(account.vipSettings)
      this.VIPLoanFilter.show = isValidLoanType && isValidVipSettings
      this.returnedFilter.show = (loanType === DataType.LoanStatus.AGENT_REVIEW.text && this.isShowElement(DataType.PrivilegeCode.RETURNED_FROM_UNDERWRITER_REVIEW, DataType.PrivilegeType.READABLE))
    },
    initCorrectorFilter (loanStatus) {
      const account = this.$store.getters.getAccount
      const isValidLoanType = [DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.CORRECTOR_REVIEW.value].includes(loanStatus)
      const isValidVipSettings = [0, 1].includes(account.vipSettings)
      this.VIPLoanFilter.show = isValidLoanType && isValidVipSettings
    },
    clickBtnHandler (loanStatus) {
      switch (loanStatus) {
        case DataType.LoanStatus.TRIBE_REVIEW.value:
          this.batchApproveDialog = true
          break
        case DataType.LoanStatus.GOOD_STANDING_PAID_OFF.value:
        case DataType.LoanStatus.PAID_OFF.value:
        case DataType.LoanStatus.WARNING_PAID_OFF.value:
        case DataType.LoanStatus.IN_HOUSE_REPLAN_PAID_OFF.value:
        case DataType.LoanStatus.IN_HOUSE_SETTLEMENT_PAID_OFF.value:
          this.exportPaidOffDialog.display = true
          this.exportPaidOffDialog.loanStatus = loanStatus
          break
        case DataType.LoanStatus.UNDERWRITER_REVIEW.value:
          this.exportUnderWriterDialog.display = true
          this.exportUnderWriterDialog.loanStatus = loanStatus
          break
        default:
          break
      }
    },
    clickProcessBtn (index) {
      if (this.dataWorkQueue[index].title === 'Suspected Litigant') {
        popup.popupForQuestion('Do you want to process all data?', { title: 'Please confirm' }, function () {
          OriginationBusinessApi.verifyBatch()
        })
      }
    },
    clickDenyAll (index) {
      const workQueue = this.dataWorkQueue[index]
      const $this = this
      const portfolioIdList = this.$store.getters.getRuntimePortfolio
      const request = { portfolioIdList }
      if (workQueue.title === 'Tribe NOAA Review') {
        popup.popupForQuestion('Do you want to deny all data?', { title: 'Please confirm' }, function () {
          OriginationBusinessApi.batchUpdateLoanStatusToWithdrawn(request, function () {
            workQueue.isLoading = true
            const loanStatus = typeof workQueue.status === 'number' ? [workQueue.status] : workQueue.status
            const requestInput = $this.returnRequestInput(loanStatus, workQueue.indexOfPage, workQueue.features, workQueue.filter, workQueue)
            $this.getQueueItems(requestInput, workQueue.key)
            $this.getQueueCount(requestInput, workQueue.key)
            popup.popupForSuccess('Operation In Progress, Please check back later!')
          }, function (result) {
            popup.popupForError(result.message)
          }, true)
        })
      }
      workQueue.isLoading = false
    },
    async clickItem (index) {
      this.sliderColor = this.dataWorkQueue[index].color[0]
      this.thColor = this.dataWorkQueue[index].color[0]
      this.tabColor = this.dataWorkQueue[index].color[1]
      let workQueue
      this.activeWorkQueue = this.dataWorkQueue[index]
      if (this.flag && this.activeWorkQueue.status !== this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        this.clickItemIndex = index
        workQueue = this.dataWorkQueue[this.clickItemIndex]
        if (workQueue.features === 'LOAN_PERSONAL_DATA, LOAN_OPERATION_DATA, LOAN_LOCK_DATA, LOAN_PAYMENT_OPTION_DATA, LOAN_STATUS_DATA, LOAN_CONSULTATION_DATA, LOAN_STATUS_UPDATE_DATA') {
          workQueue.features = 'LOAN_PERSONAL_DATA, LOAN_OPERATION_DATA, LOAN_LOCK_DATA, LOAN_PAYMENT_OPTION_DATA, LOAN_STATUS_DATA, LOAN_STATUS_UPDATE_DATA'
        }
      } else if (this.flag && this.activeWorkQueue.status === this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        this.clickItemIndex = index
        this.clickItemIndexTable = index
        workQueue = this.dataWorkQueue[this.clickItemIndex]
        if (workQueue.features === 'LOAN_PERSONAL_DATA, LOAN_OPERATION_DATA, LOAN_LOCK_DATA, LOAN_PAYMENT_OPTION_DATA, LOAN_STATUS_DATA, LOAN_CONSULTATION_DATA, LOAN_STATUS_UPDATE_DATA') {
          workQueue.features = 'LOAN_PERSONAL_DATA, LOAN_OPERATION_DATA, LOAN_LOCK_DATA, LOAN_PAYMENT_OPTION_DATA, LOAN_STATUS_DATA, LOAN_STATUS_UPDATE_DATA'
        }
        this.dataWorkQueue[this.clickItemIndex].items = []
        if (this.isShowElement(DataType.PrivilegeCode.IS_DISPLAY_UNDERWRITER_QUEUE_AMOUNT, DataType.PrivilegeType.READABLE)) {
          this.runtimeHeader = LIST_TABLE_HEADER.WORK_QUEUE_UNDERWRITER_AMOUNT_TABLE_HEADERS
        } else {
          this.runtimeHeader = LIST_TABLE_HEADER.WORK_QUEUE_UNDERWRITER_TABLE_HEADERS
        }
        this.pagination.index = 1
        this.options.page = 1
        this.options.pageCount = 50
        workQueue.indexOfPage = 1
        this.runtimeHeader = this.headers
        for (const it of this.layout.setting.workQueue) {
          if (this.isShowElement(it.code, this.assist.dataType.PrivilegeType.READABLE)) {
            this.dataWorkQueueTable.push(it)
          }
        }
        this.sliderColor = this.dataWorkQueueTable[this.clickItemIndex].color[0]
        this.thColor = this.dataWorkQueueTable[this.clickItemIndex].color[0]
        this.tabColor = this.dataWorkQueueTable[this.clickItemIndex].color[1]
        this.setUI()
      } else if (!this.flag) {
        this.clickItemIndexTable = index
        workQueue = this.dataWorkQueue[this.clickItemIndexTable]
        if (workQueue.features === 'LOAN_PERSONAL_DATA, LOAN_OPERATION_DATA, LOAN_LOCK_DATA, LOAN_PAYMENT_OPTION_DATA, LOAN_STATUS_DATA, LOAN_CONSULTATION_DATA, LOAN_STATUS_UPDATE_DATA') {
          workQueue.features = 'LOAN_PERSONAL_DATA, LOAN_OPERATION_DATA, LOAN_LOCK_DATA, LOAN_PAYMENT_OPTION_DATA, LOAN_STATUS_DATA, LOAN_STATUS_UPDATE_DATA'
        }
        this.pagination.index = 1
        this.options.page = 1
        this.options.pageCount = 0
        workQueue.indexOfPage = 1
        this.dataWorkQueue[this.clickItemIndexTable].items = []
        /**
         * if currentLoanStatus is underwriter review, table header will be change
         */
        if (workQueue.status === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
          if (this.isShowElement(DataType.PrivilegeCode.IS_DISPLAY_UNDERWRITER_QUEUE_AMOUNT, DataType.PrivilegeType.READABLE)) {
            this.runtimeHeader = LIST_TABLE_HEADER.WORK_QUEUE_UNDERWRITER_AMOUNT_TABLE_HEADERS
          } else {
            this.runtimeHeader = LIST_TABLE_HEADER.WORK_QUEUE_UNDERWRITER_TABLE_HEADERS
          }
        } else {
          this.runtimeHeader = this.headers
        }
      }
      const loanStatus = typeof workQueue.status === 'number' ? [workQueue.status] : workQueue.status
      this.initCorrectorFilter(loanStatus)
      this.initWithdrawnFilter(loanStatus)
      this.initUnderwriterFilter(loanStatus)
      this.initAgentFilter(workQueue.title)
      if (this.assist.tool.isEmpty(this.dataWorkQueue[this.clickItemIndex].items) || this.dataWorkQueue[this.clickItemIndex].items.length === 0 ||
        (loanStatus[0] === DataType.LoanStatus.POSITIVE_WITHDRAWN.value || loanStatus[0] === DataType.LoanStatus.NEGATIVE_WITHDRAWN.value) || !this.flag
      ) {
        const requestInput = this.returnRequestInput(loanStatus, 1, workQueue.features, workQueue.filter, workQueue)
        if (this.isShowElement(workQueue.code, DataType.PrivilegeType.READABLE)) {
          this.getQueueItems(requestInput, workQueue.key)
        }
        if (this.isShowElement(workQueue.code, DataType.PrivilegeType.READABLE) &&
          (loanStatus[0] === DataType.LoanStatus.POSITIVE_WITHDRAWN.value || loanStatus[0] === DataType.LoanStatus.NEGATIVE_WITHDRAWN.value)
        ) {
          this.getQueueCount(requestInput, workQueue.key)
        }
      }
      if ((this.VIPLoanFilter.isVipLoan && (this.assist.dataType.LoanStatus.CORRECTOR_REVIEW.value || this.assist.dataType.LoanStatus.AGENT_REVIEW.value)) ||
        (!this.VIPLoanFilter.isVipLoan && this.assist.dataType.LoanStatus.AGENT_REVIEW.value)) {
        const requestInput = this.returnRequestInput(loanStatus, 1, workQueue.features, workQueue.filter, workQueue)
        this.getQueueCount(requestInput, workQueue.key)
        if (this.VIPLoanFilter.isVipLoan) {
          this.getQueueItems(requestInput, workQueue.key)
        }
      }
    },
    showDateRange (data) {
      if (data.endDate === '' && data.startDate === '') {
        this.showRange = false
        this.sortByPosition = 'toLeft'
        this.sortByStyle = 'position: absolute; left: 255px; top: 15px;'
      } else {
        this.showRange = true
        this.dateRange = '(' + data.startDate + ' ~ ' + data.endDate + ')'
        this.sortByPosition = 'toMLeft'
        this.sortByStyle = 'position: absolute; left: 417px; top: 15px;'
      }
      this.showWithdrawnReasonPosition()
      this.showUnderwriterButtonPosition()
    },
    showWithdrawnReasonPosition () {
      if (this.showRange && this.showSortBy) {
        this.withdrawnFilter.style = 'position: absolute; left: 790px; top: 15px;'
        this.withdrawnFilter.selectStyle = 'position: absolute; left: 935px; top: -10px; width: 12%;'
      } else if (this.showRange && !this.showSortBy) {
        this.withdrawnFilter.style = 'position: absolute; left: 650px; top: 15px;'
        this.withdrawnFilter.selectStyle = 'position: absolute; left: 780px; top: -10px; width: 12%;'
      } else if (!this.showRange && this.showSortBy) {
        this.withdrawnFilter.style = 'position: absolute; left: 700px; top: 15px;'
        this.withdrawnFilter.selectStyle = 'position: absolute; left: 848px; top: -10px; width: 12%;'
      } else {
        this.withdrawnFilter.style = 'position: absolute; left: 310px; top: 15px;'
        this.withdrawnFilter.selectStyle = 'position: absolute; left: 460px; top: -10px; width: 12%;'
      }
    },
    showUnderwriterButtonPosition () {
      if (this.showRange && this.showSortBy) {
        this.sameDayFilter.style = 'position: absolute; left: 873px; top: -5px;'
        this.sameDayFilter.textStyle = 'position: absolute; left: 760px; top: 17px;'
        this.reapprovedFilter.style = 'position: absolute; left: 1020px; top: -5px;'
        this.reapprovedFilter.textStyle = 'position: absolute; left: 924px; top: 17px;'
        this.defaultDisbursementModeFilter.style = 'position: absolute; left: 1188px; top: -5px;'
        this.defaultDisbursementModeFilter.textStyle = 'position: absolute; left: 1068px; top: 17px;'
        this.returningFilter.style = 'position: absolute; left: 1390px; top: -5px;'
        this.returningFilter.textStyle = 'position: absolute; left: 1238px; top: 17px;'
        this.languageselected.style = 'position: absolute; left: 625px; top: -5px;'
        this.languageselected.textStyle = 'position: absolute; left: 549px; top: 17px;'
        this.returnedFilter.style = 'position: absolute; left: 1000px; top: -5px;'
        this.returnedFilter.textStyle = 'position: absolute; left: 795px; top: 17px;'
        this.languageText.style = 'position: absolute; left: 653px; top: 17px;'
        this.consultationFilter.textStyle = 'position: absolute; left: 27px; top: 50px;'
        this.consultationFilter.style = 'position: absolute; left: 190px; top: 28px;'
        this.VIPLoanFilter.textStyle = 'position: absolute; left: 1060px; top: 17px;'
        this.VIPLoanFilter.style = 'position: absolute; left: 1160px; top :-5px;'
      } else if (this.showRange && !this.showSortBy) {
        this.sameDayFilter.style = 'position: absolute; left: 765px; top: -5px;'
        this.sameDayFilter.textStyle = 'position: absolute; left: 650px; top: 17px;'
        this.reapprovedFilter.style = 'position: absolute; left: 905px; top: -5px;'
        this.reapprovedFilter.textStyle = 'position: absolute; left: 811px; top: 17px;'
        this.defaultDisbursementModeFilter.style = 'position: absolute; left: 1065px; top: -5px;'
        this.defaultDisbursementModeFilter.textStyle = 'position: absolute; left: 945px; top: 17px;'
        this.returningFilter.style = 'position: absolute; left: 1265px; top: -5px;'
        this.returningFilter.textStyle = 'position: absolute; left: 1110px; top: 17px;'
        this.languageselected.style = 'position: absolute; left: 500px; top: -5px;'
        this.languageselected.textStyle = 'position: absolute; left: 420px; top: 17px;'
        this.languageText.style = 'position: absolute; left: 498px; top: 17px;'
        this.consultationFilter.textStyle = 'position: absolute; left: 1328px; top: 17px;'
        this.consultationFilter.style = 'position: absolute; left: 1490px; top: -5px;'
        this.VIPLoanFilter.textStyle = 'position: absolute; left: 1000px; top: 17px;'
        this.VIPLoanFilter.style = 'position: absolute; left: 1090px; top :-5px;'
      } else if (!this.showRange && this.showSortBy) {
        this.sameDayFilter.style = 'position: absolute; left: 750px; top: -5px;'
        this.sameDayFilter.textStyle = 'position: absolute; left: 633px; top: 17px;'
        this.reapprovedFilter.style = 'position: absolute; left: 900px; top: -5px;'
        this.reapprovedFilter.textStyle = 'position: absolute; left: 800px; top: 17px;'
        this.defaultDisbursementModeFilter.style = 'position: absolute; left: 1072px; top: -5px;'
        this.defaultDisbursementModeFilter.textStyle = 'position: absolute; left: 950px; top: 17px;'
        this.returningFilter.style = 'position: absolute; left: 1276px; top: -5px;'
        this.returningFilter.textStyle = 'position: absolute; left: 1122px; top: 17px;'
        this.languageselected.style = 'position: absolute; left: 485px; top: -5px;'
        this.languageselected.textStyle = 'position: absolute; left: 400px; top: 17px;'
        this.languageText.style = 'position: absolute; left: 528px; top: 17px;'
        this.returnedFilter.style = 'position: absolute; left: 922px; top: -5px;'
        this.returnedFilter.textStyle = 'position: absolute; left: 720px; top: 17px;'
        this.consultationFilter.textStyle = 'position: absolute; left: 1328px; top: 17px;'
        this.consultationFilter.style = 'position: absolute; left: 1490px; top: -5px;'
        this.VIPLoanFilter.textStyle = 'position: absolute; left: 990px; top: 17px;'
        this.VIPLoanFilter.style = 'position: absolute; left: 1090px; top :-5px;'
      } else {
        this.sameDayFilter.style = 'position: absolute; left: 420px; top: -5px;'
        this.sameDayFilter.textStyle = 'position: absolute; left: 300px; top: 17px;'
        this.reapprovedFilter.style = 'position: absolute; left: 620px; top: -5px;'
        this.reapprovedFilter.textStyle = 'position: absolute; left: 520px; top: 17px;'
        this.defaultDisbursementModeFilter.style = 'position: absolute; left: 850px; top: -5px;'
        this.defaultDisbursementModeFilter.textStyle = 'position: absolute; left: 720px; top: 17px;'
        this.returningFilter.style = 'position: absolute; left: 1080px; top: -5px;'
        this.returningFilter.textStyle = 'position: absolute; left: 920px; top: 17px;'
        this.languageselected.style = 'position: absolute; left: 650px; top: -5px;'
        this.languageselected.textStyle = 'position: absolute; left: 575px; top: 17px;'
        this.returnedFilter.style = 'position: absolute; left: 886px; top: -5px;'
        this.returnedFilter.textStyle = 'position: absolute; left: 775px; top: 17px;'
        this.VIPLoanFilter.textStyle = 'position: absolute; left: 1000px; top: 17px;'
        this.VIPLoanFilter.style = 'position: absolute; left: 1100px; top :-5px;'
      }
    },
    isShowElement (code, value) {
      let result = false
      const authorization = this.store.getters.getAuthorization
      if ($tool.isNotEmpty(authorization)) {
        const privileges = authorization.privileges
        result = Authentication.matchElementPrivilege(privileges, code, value)
      }
      return result
    },
    dialogEventHandler (action) {
      switch (action) {
        case DataType.DialogActionEnum.DISPLAY:
          this.layoutData.dialog.display = true
          break
        case DataType.DialogActionEnum.HIDE:
          this.layoutData.dialog.display = false
          break
        case DataType.DialogActionEnum.OPERATE:
          this.layoutData.dialog.display = false
          if (this.flag && this.activeWorkQueue.status !== this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
            this.initQueueData(this.clickItemIndex)
          } else {
            this.initQueueDataTable(this.clickItemIndexTable)
          }
          break
        default:
          break
      }
    },
    onLanguageSelect () {
      if (this.flag && this.activeWorkQueue.status !== this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        this.initQueueData(this.clickItemIndex)
      } else {
        this.initQueueDataTable(this.clickItemIndexTable)
      }
    },
    sortByEventHandler (sortKey) {
      this.layoutData.sortBy = sortKey
      this.showSortBy = true
      this.sortBy = '(' + this.layout.sortBy[sortKey - 1].text + ')'
      this.showWithdrawnReasonPosition()
      this.showUnderwriterButtonPosition()
      if (this.flag && this.activeWorkQueue.status !== this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        this.initQueueData(this.clickItemIndex)
      } else {
        this.initQueueDataTable(this.clickItemIndexTable)
      }
    },
    /**
     * Same Day, Reapproved, Instant Funding, Withdrawn Reason
     */
    filterChange () {
      this.dataWorkQueue[this.clickItemIndexTable].items = []
      let workQueue
      if (this.flag && this.activeWorkQueue.status !== this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        workQueue = this.dataWorkQueue[this.clickItemIndex]
      } else {
        workQueue = this.dataWorkQueueTable[this.clickItemIndexTable]
      }
      if (this.consultationFilter.isConsultation && workQueue.loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        workQueue.features = 'LOAN_PERSONAL_DATA, LOAN_OPERATION_DATA, LOAN_LOCK_DATA, LOAN_PAYMENT_OPTION_DATA, LOAN_STATUS_DATA, LOAN_CONSULTATION_DATA, LOAN_STATUS_UPDATE_DATA'
      } else {
        workQueue.features = 'LOAN_PERSONAL_DATA, LOAN_OPERATION_DATA, LOAN_LOCK_DATA, LOAN_PAYMENT_OPTION_DATA, LOAN_STATUS_DATA, LOAN_STATUS_UPDATE_DATA'
      }
      const loanStatus = typeof workQueue.status === 'number' ? [workQueue.status] : workQueue.status
      const requestInput = this.returnRequestInput(loanStatus, 1, workQueue.features, workQueue.filter, workQueue)
      if (this.isShowElement(workQueue.code, DataType.PrivilegeType.READABLE)) {
        this.getQueueCount(requestInput, workQueue.key)
      }
      if (this.isShowElement(workQueue.code, DataType.PrivilegeType.READABLE)) {
        this.getQueueItems(requestInput, workQueue.key)
      }
    },
    initQueueData (index) {
      this.dataWorkQueue = []
      for (const it of this.layout.setting.workQueue) {
        if (this.isShowElement(it.code, this.assist.dataType.PrivilegeType.READABLE)) {
          this.dataWorkQueue.push(it)
        }
      }
      this.clickItemIndex = index
      this.clearWorkQueue()
      if ($tool.isEmpty(this.$store.getters.getRuntimePortfolio)) {
        return
      }
      if (this.loanPhase === DataType.LoanPhaseEnum.LOAN_COLLECTION.value && $tool.isEmpty(this.store.getters.getRoleCode)) {
        return
      }
      if (this.dataWorkQueue.length !== 0) {
        for (const workQueue of this.dataWorkQueue) {
          if (this.isShowElement(workQueue.code, DataType.PrivilegeType.READABLE)) {
            const loanStatus = typeof workQueue.status === 'number' ? [workQueue.status] : workQueue.status
            const requestInput = this.returnRequestInput(loanStatus, 1, workQueue.features, workQueue.filter, workQueue)
            this.getQueueCount(requestInput, workQueue.key)
          }
        }
        const workQueue = this.dataWorkQueue[this.clickItemIndex]
        this.initAgentFilter(workQueue.title)
        if (this.isShowElement(workQueue.code, DataType.PrivilegeType.READABLE)) {
          const loanStatus = typeof workQueue.status === 'number' ? [workQueue.status] : workQueue.status
          const requestInput = this.returnRequestInput(loanStatus, 1, workQueue.features, workQueue.filter, workQueue)
          this.getQueueItems(requestInput, workQueue.key)
        }
      }
    },
    initQueueDataTable (index) {
      this.dataWorkQueueTable = []

      // init table header
      this.runtimeHeader = this.headers
      for (const it of this.layout.setting.workQueue) {
        if (this.isShowElement(it.code, this.assist.dataType.PrivilegeType.READABLE)) {
          this.dataWorkQueueTable.push(it)
        }
      }
      this.clickItemIndexTable = index
      this.clearWorkQueue()
      if ($tool.isEmpty(this.$store.getters.getRuntimePortfolio)) {
        return
      }
      if (this.loanPhase === DataType.LoanPhaseEnum.LOAN_COLLECTION.value && $tool.isEmpty(this.store.getters.getRoleCode)) {
        return
      }
      if (this.dataWorkQueueTable.length !== 0) {
        for (const workQueue of this.dataWorkQueueTable) {
          if (this.isShowElement(workQueue.code, DataType.PrivilegeType.READABLE)) {
            const loanStatus = typeof workQueue.status === 'number' ? [workQueue.status] : workQueue.status
            const requestInput = this.returnRequestInput(loanStatus, 1, workQueue.features, workQueue.filter, workQueue)
            this.getQueueCount(requestInput, workQueue.key)
          }
        }
        const workQueue = this.dataWorkQueueTable[this.clickItemIndexTable]
        if (this.isShowElement(workQueue.code, DataType.PrivilegeType.READABLE)) {
          const loanStatus = typeof workQueue.status === 'number' ? [workQueue.status] : workQueue.status
          /**
           * if currentLoanStatus is underwriter review, table header will be change
           */
          if (workQueue.status === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
            if (this.isShowElement(DataType.PrivilegeCode.IS_DISPLAY_UNDERWRITER_QUEUE_AMOUNT, DataType.PrivilegeType.READABLE)) {
              this.runtimeHeader = LIST_TABLE_HEADER.WORK_QUEUE_UNDERWRITER_AMOUNT_TABLE_HEADERS
            } else {
              this.runtimeHeader = LIST_TABLE_HEADER.WORK_QUEUE_UNDERWRITER_TABLE_HEADERS
            }
          } else {
            this.runtimeHeader = this.headers
          }
          const requestInput = this.returnRequestInput(loanStatus, 1, workQueue.features, workQueue.filter, workQueue)
          this.getQueueItems(requestInput, workQueue.key)
        }
      }
    },
    changePageQueueDataTable (index, func) {
      this.clickItemIndexTable = index
      const workQueue = this.dataWorkQueueTable[this.clickItemIndexTable]
      if (this.dataWorkQueueTable.length !== 0) {
        switch (func) {
          case 'sub':
            workQueue.indexOfPage--
            break
          case 'add':
            workQueue.indexOfPage++
            break
          default:
            break
        }
        workQueue.items = []
        if (this.isShowElement(workQueue.code, DataType.PrivilegeType.READABLE)) {
          const loanStatus = typeof workQueue.status === 'number' ? [workQueue.status] : workQueue.status
          const requestInput = this.returnRequestInput(loanStatus, workQueue.indexOfPage, workQueue.features, workQueue.filter, workQueue)
          this.getQueueItems(requestInput, workQueue.key)
        }
      }
    },
    async getQueueCount (requestInput, key) {
      const { portfolioIds, loanStatuses, filter, beginDate, endDate, phase, transactionProvider, collectionProvider } = requestInput
      const input = {
        portfolioIds: portfolioIds,
        loanStatuses: loanStatuses,
        filter: filter,
        phase: phase,
        beginDate: beginDate,
        endDate: endDate,
        transactionProvider: transactionProvider,
        collectionProvider: collectionProvider
      }
      if (this.queueType === DataType.QueueTypeEnum.SpecialQueue.value) {
        switch (this.loanPhase) {
          case DataType.LoanPhaseEnum.LOAN_COLLECTION.value:
            input.specialType = DataType.PaymentSpecialTypeEnum.CORRECTION_CODE.value
            await this.getWAQueueCount(input, key)
            break
          case DataType.LoanPhaseEnum.PAYMENT_PROCESSING.value:
            await this.getSpecialQueueCount(input, key)
            break
          default:
            break
        }
      } else {
        switch (this.loanPhase) {
          case DataType.LoanPhaseEnum.LOAN_COLLECTION.value:
            if (this.isOverflowQueue) {
              input.loanFlag = 2048
              await this.getOverflowQueueCount(input, key)
            } else {
              await this.getWAQueueCount(input, key)
            }
            break
          case DataType.LoanPhaseEnum.PAYMENT_PROCESSING.value:
            await this.getPPSQueueCount(input, key)
            break
          default:
            await this.getWorkQueueCount(input, key)
            break
        }
      }
    },
    async getQueueItems (requestInput, key) {
      const input = Object.assign({}, requestInput, { sortBy: this.layoutData.sortBy })
      if (this.queueType === DataType.QueueTypeEnum.SpecialQueue.value) {
        switch (this.loanPhase) {
          case DataType.LoanPhaseEnum.LOAN_COLLECTION.value:
            input.specialType = DataType.PaymentSpecialTypeEnum.CORRECTION_CODE.value
            await this.getWAQueueItem(input, key)
            break
          case DataType.LoanPhaseEnum.PAYMENT_PROCESSING.value:
            await this.getSpecialQueueItem(input, key)
            break
          default:
            break
        }
      } else {
        switch (this.loanPhase) {
          case DataType.LoanPhaseEnum.LOAN_COLLECTION.value:
            if (this.isOverflowQueue) {
              input.loanFlag = 2048
              await this.getOverflowQueueItem(input, key)
            } else {
              await this.getWAQueueItem(input, key)
            }
            break
          case DataType.LoanPhaseEnum.PAYMENT_PROCESSING.value:
            await this.getPPSQueueItem(input, key)
            break
          default:
            await this.getWorkQueueItem(input, key)
            break
        }
      }
    },
    async getWAQueueItem (requestInput, key) {
      const $this = this
      await CollectionApi.getWAQueueItem(requestInput, function (data) {
        if ($this.flag && $this.activeWorkQueue.status !== $this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
          $this.getWAQueueItemCallBack(data.data, key)
        } else {
          $this.getWAQueueItemCallBackTable(data.data, key)
        }
      }, function (err) {
        console.error(err)
      })
    },
    async getPPSQueueItem (requestInput, key) {
      const $this = this
      await ProcessingApi.getPPSQueueItem(requestInput, function (data) {
        if ($this.flag && $this.activeWorkQueue.status !== $this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
          $this.getQueueItemCallBack(data, key)
        } else {
          $this.getQueueItemCallBackTable(data, key)
        }
      }, function (err) {
        console.error(err)
      })
    },
    async getOverflowQueueItem (requestInput, key) {
      const $this = this
      await CollectionApi.getOverflowQueueItem(requestInput, function (data) {
        if ($this.flag && $this.activeWorkQueue.status !== $this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
          $this.getOverflowQueueItemCallBack(data.data, key)
        } else {
          $this.getOverflowQueueItemCallBackTable(data.data, key)
        }
      }, function (err) {
        console.error(err)
      })
    },
    async getSpecialQueueItem (requestInput, key) {
      const $this = this
      await ProcessingApi.getSpecialQueueItem(requestInput, function (data) {
        if ($this.flag && $this.activeWorkQueue.status !== $this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
          $this.getQueueItemCallBack(data, key)
        } else {
          $this.getQueueItemCallBackTable(data, key)
        }
      }, function (err) {
        console.error(err)
      })
    },
    async getWorkQueueItem (requestInput, key) {
      const $this = this
      if (DataType.LoanStatus.UNDERWRITER_REVIEW.value === requestInput.loanStatuses[0] && $tool.isEmpty(requestInput.sortBy)) {
        requestInput = Object.assign(requestInput, { sortBy: SystemEnum.SORT_ORDER_BY.SUBMITTED_AT_ASC.value })
      }
      await LoanResourceApi.getWorkQueueItem(requestInput, function (data) {
        if ($this.flag && $this.activeWorkQueue.status !== $this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
          $this.getQueueItemCallBack(data, key)
        } else {
          $this.getQueueItemCallBackTable(data, key)
        }
      }, function (err) {
        console.error(err)
      })
    },
    async getWAQueueCount (input, key) {
      const $this = this
      await CollectionApi.getWAQueueCount(input, function (data) {
        $this.getQueueCountCallBack(data, key)
      }, function (err) {
        console.error(err)
      })
    },
    async getOverflowQueueCount (input, key) {
      const $this = this
      await CollectionApi.getOverflowQueueCount(input, function (data) {
        $this.getQueueCountCallBack(data, key)
      }, function (err) {
        console.error(err)
      })
    },
    async getPPSQueueCount (input, key) {
      const $this = this
      input.features = 'LOAN_STATUS_DATA'
      await ProcessingApi.getPPSQueueCount(input, function (data) {
        $this.getQueueCountCallBack(data, key)
      }, function (err) {
        console.error(err)
      })
    },
    async getSpecialQueueCount (input, key) {
      const $this = this
      await ProcessingApi.getSpecialQueueCount(input, function (data) {
        $this.getQueueCountCallBack(data, key)
      }, function (err) {
        console.error(err)
      })
    },
    async getWorkQueueCount (input, key) {
      const $this = this
      await LoanResourceApi.getWorkQueueCount(input, function (data) {
        $this.getQueueCountCallBack(data, key)
      }, function (err) {
        console.error(err)
      })
    },
    async scrollHandler (workQueue, index) {
      if (!workQueue.isEnd && this.clickItemIndex === index && !workQueue.isLoading) {
        workQueue.isEnd = true
        workQueue.isLoading = true
        workQueue.indexOfPage++
        var status = []
        if ((typeof workQueue.status) === 'number') {
          status = [workQueue.status]
        } else {
          for (var i = 0; i < workQueue.status.length; i++) {
            status.push(workQueue.status[i])
          }
        }
        const requestInput = this.returnRequestInput(status, workQueue.indexOfPage, workQueue.features, workQueue.filter, workQueue)
        await this.getQueueItems(requestInput, workQueue.key)
      }
    },
    getQueueCountCallBack (data, key) {
      this.dataWorkQueue.map(queue => {
        if (queue.key === key) {
          queue.count = data
        }
      })
    },
    getQueueItemCallBack (data, key) {
      this.dataWorkQueue.map(queue => {
        if (queue.key === key) {
          queue.isLoading = false
          queue.isEnd = ($tool.isEmpty(data) || data.length !== 30)
          if (queue.indexOfPage === 1) {
            queue.items = data
          } else {
            queue.items = queue.items.concat(data)
          }
        }
      })
    },
    getQueueItemCallBackTable (data, key) {
      this.dataWorkQueueTable.map(queue => {
        if (queue.key === key) {
          queue.isLoading = false
          queue.isEnd = ($tool.isEmpty(data) || data.length !== this.options.itemsPerPage)
          if (queue.indexOfPage === 1) {
            queue.items = data
          } else {
            queue.items = queue.items.concat(data)
          }
        }
      })
      this.tableData = this.dataWorkQueueTable[this.clickItemIndexTable].items
      this.options.pageCount = this.dataWorkQueueTable[this.clickItemIndexTable].count
      this.tableData.map((value, index) => {
        this.getItemValue(value, index)
        this.getItemIcon(value)

        value.loanDetails = {
          loanNo: value.loanNo,
          name: value.name,
          requested_amount: value.requested_amount
        }
      })
      this.tableData = _.clone(this.tableData)
      this.$forceUpdate()
    },
    getWAQueueItemCallBack (data, key) {
      this.dataWorkQueue.map(queue => {
        if (queue.key === key) {
          queue.isLoading = false
          queue.isEnd = ($tool.isEmpty(data?.resultData) || data.resultData.length !== 30)
          if (key === SystemEnum.WORK_QUEUE_ENUM.BROKEN_PROMISE.key) {
            queue.beginSize = data.beginSize
            queue.rejectedPage = data.rejectedPage
            queue.searchRejected = data.searchRejected
          }
          if (queue.indexOfPage === 1) {
            queue.items = $tool.isNotEmpty(data?.resultData) ? data?.resultData : []
          } else {
            queue.items = queue.items.concat(data.resultData)
          }
        }
      })
    },
    getOverflowQueueItemCallBack (data, key) {
      this.dataWorkQueue.map(queue => {
        if (queue.key === key) {
          queue.isLoading = false
          queue.isEnd = ($tool.isEmpty(data?.resultData) || data.resultData.length !== 30)
          if (key === SystemEnum.WORK_QUEUE_ENUM.BROKEN_PROMISE.key) {
            queue.beginSize = data.beginSize
            queue.rejectedPage = data.rejectedPage
            queue.searchRejected = data.searchRejected
          }
          if (queue.indexOfPage === 1) {
            queue.items = data?.resultData
          } else {
            queue.items = queue.items.concat(data.resultData)
          }
        }
      })
    },
    getWAQueueItemCallBackTable (data, key) {
      this.dataWorkQueue.map(queue => {
        if (queue.key === key) {
          queue.isLoading = false
          queue.isEnd = ($tool.isEmpty(data?.resultData) || data.length !== this.options.itemsPerPage)
          if (key === SystemEnum.WORK_QUEUE_ENUM.BROKEN_PROMISE.key) {
            queue.beginSize = data.beginSize
            queue.rejectedPage = data.rejectedPage
            queue.searchRejected = data.searchRejected
          }
          if (queue.indexOfPage === 1) {
            queue.items = data?.resultData
          } else {
            queue.items = queue.items.concat(data.resultData)
          }
        }
      })
      this.tableData = this.dataWorkQueueTable[this.clickItemIndexTable].items
      this.options.pageCount = this.dataWorkQueueTable[this.clickItemIndexTable].count
      this.tableData.map((value, index) => {
        this.getItemValue(value, index)
        this.getItemIcon(value)

        value.loanDetails = {
          loanNo: value.loanNo,
          name: value.name,
          requested_amount: value.requested_amount
        }
      })
      this.tableData = _.clone(this.tableData)
      this.$forceUpdate()
    },
    getOverflowQueueItemCallBackTable (data, key) {
      this.dataWorkQueue.map(queue => {
        if (queue.key === key) {
          queue.isLoading = false
          queue.isEnd = ($tool.isEmpty(data.resultData) || data.length !== this.options.itemsPerPage)
          if (key === SystemEnum.WORK_QUEUE_ENUM.BROKEN_PROMISE.key) {
            queue.beginSize = data.beginSize
            queue.rejectedPage = data.rejectedPage
            queue.searchRejected = data.searchRejected
          }
          if (queue.indexOfPage === 1) {
            queue.items = data.resultData
          } else {
            queue.items = queue.items.concat(data.resultData)
          }
        }
      })
      this.tableData = this.dataWorkQueueTable[this.clickItemIndexTable].items
      this.options.pageCount = this.dataWorkQueueTable[this.clickItemIndexTable].count
      this.tableData.map((value, index) => {
        this.getItemValue(value, index)
        this.getItemIcon(value)

        value.loanDetails = {
          loanNo: value.loanNo,
          name: value.name,
          requested_amount: value.requested_amount
        }
      })
      this.tableData = _.clone(this.tableData)
      this.$forceUpdate()
    },
    baseReturnRequestInput (loanStatus, indexOfPage, features, filter, workQueue, size) {
      let loanPhase = this.loanPhase
      let transactionProvider
      let lcsInput
      let currentFilter = {}
      if ($tool.isNotEmpty(filter)) {
        currentFilter = filter
      }
      const status = loanStatus[0]
      if (loanPhase === DataType.LoanPhaseEnum.LOAN_COLLECTION.value && this.store.getters.getRoleCode === DataType.RoleEnum.COLLECTION_AGENT.code && this.isInHouseQueue(status)) {
        currentFilter.assignedId = this.store.getters.getAccount.id
      }
      if ($tool.isNotEmpty(loanStatus) && loanStatus[0] === DataType.LoanStatus.APPROVED.value) {
        loanPhase = DataType.LoanPhaseEnum.APPROVED.value
      }
      if (loanPhase === DataType.LoanPhaseEnum.LOAN_COLLECTION.value) {
        transactionProvider = 10
        if (workQueue.key === SystemEnum.WORK_QUEUE_ENUM.BROKEN_PROMISE.key) {
          lcsInput = { beginSize: workQueue.beginSize, rejectedPage: workQueue.rejectedPage, searchRejected: workQueue.searchRejected }
        }
      }
      if ($tool.isNotEmpty(this.withdrawnFilter.enum) && $tool.isNotEmpty(loanStatus)) {
        const withdrawnEnum = this.withdrawnFilter.enum
        if (
          (loanStatus[0] === DataType.LoanStatus.POSITIVE_WITHDRAWN.value && withdrawnEnum.value.toString().startsWith(1)) ||
          (loanStatus[0] === DataType.LoanStatus.NEGATIVE_WITHDRAWN.value && withdrawnEnum.value.toString().startsWith(2))
        ) {
          currentFilter.withdrawnReason = withdrawnEnum.value
        }
      }
      if ($tool.isNotEmpty(loanStatus) && loanStatus[0] === DataType.LoanStatus.CORRECTOR_REVIEW.value) {
        currentFilter.isVipLoan = this.VIPLoanFilter.isVipLoan
      }
      this.languageEnum.forEach(language => {
        if (Object.prototype.hasOwnProperty.call(currentFilter, `is${language.text}`) || 'isAllLanguage' in currentFilter) {
          delete currentFilter[`is${language.text}`]
          delete currentFilter.isAllLanguage
        }
      })
      this.languageEnum.forEach(language => {
        if ($tool.isNotEmpty(loanStatus) && this.account.languagePreference === language.value && this.selectedLanguage === language.text) {
          currentFilter.isAllLanguage = true
        } else if ($tool.isNotEmpty(loanStatus) && this.selectedLanguage === `${language.text} Only`) {
          currentFilter[`is${language.text}`] = true
        }
      })
      if ($tool.isNotEmpty(loanStatus) && loanStatus[0] === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        currentFilter.isSameDay = this.sameDayFilter.isSameDay
        currentFilter.reapproved = this.reapprovedFilter.isReapproved
        currentFilter.returning = this.returningFilter.isReturning
        currentFilter.isConsultation = this.consultationFilter.isConsultation
        if (this.defaultDisbursementModeFilter.isInstantFunding) {
          currentFilter.defaultDisbursementMode = DataType.TransactionModeEnum.INSTANT_FUND.value
        }
      } else if ($tool.isNotEmpty(loanStatus) && loanStatus[0] === DataType.LoanStatus.AGENT_REVIEW.value) {
        currentFilter.isFromUw = this.returnedFilter.isFromUw
        currentFilter.isVipLoan = this.VIPLoanFilter.isVipLoan
      }
      let collectionProvider
      if ($tool.isNotEmpty(workQueue) && $tool.isNotEmpty(workQueue.key)) {
        const key = workQueue.key
        switch (key) {
          case 'pendingWA':
          case 'WA':
          case 'WAPaidOff':
            collectionProvider = DataType.CollectionProviderEnum.WAGE_ASSIGNMENT.value
            break
          case 'pendingWAI':
          case 'WAI':
          case 'WAIPaidOff':
          case 'WAIPocketed':
            collectionProvider = DataType.CollectionProviderEnum.WAGE_ASSIGNMENT_IN_HOUSE.value
            break
          case 'ThirdParty':
          case 'ThirdPartyPaidOff':
            collectionProvider = DataType.CollectionProviderEnum.THIRD_PARTY.value
            break
          default:
            break
        }
      }

      // const portfolioIds = this.store.getters.getAccount.portfolioIdList
      const portfolioIds = this.$store.getters.getRuntimePortfolio
      return {
        portfolioIds: portfolioIds,
        loanStatuses: loanStatus,
        features: features,
        filter: currentFilter,
        page: indexOfPage,
        phase: loanPhase,
        size: size,
        beginDate: this.layoutData.dialog.data.startDate,
        endDate: this.layoutData.dialog.data.endDate,
        transactionProvider: transactionProvider,
        beginSize: $tool.isNotEmpty(lcsInput) ? lcsInput.beginSize : undefined,
        rejectedPage: $tool.isNotEmpty(lcsInput) ? lcsInput.rejectedPage : undefined,
        searchRejected: $tool.isNotEmpty(lcsInput) ? lcsInput.searchRejected : undefined,
        collectionProvider: collectionProvider
      }
    },
    returnRequestInput (loanStatus, indexOfPage, features, filter, workQueue) {
      let page = 30
      if (!this.flag || this.activeWorkQueue.status === this.assist.dataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        page = this.options.itemsPerPage
      }
      return this.baseReturnRequestInput(loanStatus, indexOfPage, features, filter, workQueue, page)
    },
    isInHouseQueue (loanStatus) {
      return loanStatus === DataType.LoanStatus.IN_HOUSE_SETTLEMENT.value ||
        loanStatus === DataType.LoanStatus.IN_HOUSE_REPLAN.value ||
        loanStatus === DataType.LoanStatus.PENDING_IN_HOUSE_APPROVE.value
    },
    clearWorkQueue () {
      for (const workQueue of this.dataWorkQueue) {
        workQueue.count = 0
        workQueue.items = []
        workQueue.indexOfPage = 1
        workQueue.isEnd = true
        workQueue.isLoading = true
        if (workQueue.key === SystemEnum.WORK_QUEUE_ENUM.BROKEN_PROMISE.key) {
          workQueue.beginSize = 0
          workQueue.rejectedPage = 1
          workQueue.searchRejected = 1
        }
      }
    },
    hideDialogHandler () {
      this.batchApproveDialog = false
    },
    hideExportPaidOffDialogHandler () {
      this.exportPaidOffDialog.display = false
    },
    hideExportUnderWriterDialogHandler () {
      this.exportUnderWriterDialog.display = false
    },
    getItemValue (value, index) {
      value.name = this.tableData[index].firstName + '  ' + this.tableData[index].lastName
      value.submitted_by = $tool.isEmpty(value.submittedBy) ? '—' : $tool.formatOperatedByInTableView(this.isShowOperatedBy, JSON.parse(this.tableData[index].submittedBy), this.roleList, this.$store.getters.getAccount)
      value.audited_by = $tool.isEmpty(value.auditedBy) ? '—' : $tool.formatOperatedByInTableView(this.isShowOperatedBy, JSON.parse(this.tableData[index].auditedBy), this.roleList, this.$store.getters.getAccount)
      value.locked_by = $tool.isEmpty(value.lockedBy) ? '—' : $tool.formatOperatedByInTableView(this.isShowOperatedBy, JSON.parse(this.tableData[index].lockedBy), this.roleList, this.$store.getters.getAccount)
      value.requested_amount = $tool.fieldRender(this.tableData[index], '{requestedAmount}', 'currency')
      value.effective_date = $tool.isEmpty(value.effectiveDate) ? '—' : $tool.fieldRender(this.tableData[index], '{effectiveDate}', 'date')
      value.loan_amount = $tool.isEmpty(value.loanAmount) ? '—' : $tool.fieldRender(this.tableData[index], '{loanAmount}', 'currency')
      value.approved_amount = $tool.isEmpty(value.approvedAmount) ? '—' : $tool.fieldRender(this.tableData[index], '{approvedAmount}', 'currency')
      value.updated_at = $tool.fieldRender(this.tableData[index], '{updatedAt}', 'datetime')
      value.entered_at = $tool.fieldRender(this.tableData[index], '{enteredAt}', 'datetime')
      value.submitted_at = $tool.isEmpty(value.submittedAt) ? '—' : $tool.fieldRender(this.tableData[index], '{submittedAt}', 'datetime')
      value.signed_at = $tool.isEmpty(value.signedAt) ? '—' : $tool.fieldRender(this.tableData[index], '{signedAt}', 'datetime')
      value.days_old = $tool.isEmpty(value.daysOld) ? '—' : value.daysOld
      value.default_disbursement_mode = $tool.isEmpty(value.defaultDisbursementMode) ? '—' : $tool.fieldRender(this.tableData[index], '{defaultDisbursementMode}', null, { defaultDisbursementMode: DataType.TransactionMode })
    },
    getItemIcon (value) {
      let sameDayIcon = {
        display: false
      }
      let returningIcon = {
        style: null,
        color: null,
        title: null,
        display: false
      }
      let reSentIcon = {
        style: null,
        color: null,
        title: null,
        display: false
      }
      let creditCardIcon = {
        display: false
      }
      let compressIcon = {
        display: false
      }
      let foxExpressIcon = {
        display: false
      }

      value.features = []
      value.features[0] = sameDayIcon
      value.features[1] = returningIcon
      value.features[2] = reSentIcon
      value.features[3] = creditCardIcon
      value.features[4] = compressIcon
      value.features[5] = foxExpressIcon

      // region Same Day
      const effectiveDate = $tool.isNotEmpty(value.effectiveDate) ? parseInt(value.effectiveDate) : 0
      const currentTimestamp = $tool.isNotEmpty(value.currentTimestamp) ? parseInt(value.currentTimestamp) : 0
      if (effectiveDate !== 0) {
        if (effectiveDate >= currentTimestamp && effectiveDate <= currentTimestamp + 24 * 3600 * 1000 - 1) {
          sameDayIcon = {
            display: true
          }
        }
      } else {
        sameDayIcon = {
          display: false
        }
      }
      // endregion

      // region Returning
      const tags = value.tags
      const flags = value.flags
      if (DataType.LoanTagsEnum.SP_PO_WITHOUT_COLLECTION.value === (tags & DataType.LoanTagsEnum.SP_PO_WITHOUT_COLLECTION.value) || DataType.LoanTagsEnum.SP_CLOSE.value === (tags & DataType.LoanTagsEnum.SP_CLOSE.value)) {
        returningIcon = {
          style: 'done_all',
          color: 'color: green !important;',
          title: 'Paid Off',
          display: true
        }
      } else if (DataType.LoanTagsEnum.DP_PO_WITHOUT_COLLECTION.value === (tags & DataType.LoanTagsEnum.DP_PO_WITHOUT_COLLECTION.value) || DataType.LoanTagsEnum.DP_CLOSE.value === (tags & DataType.LoanTagsEnum.DP_CLOSE.value)) {
        returningIcon = {
          style: 'done_all',
          color: 'color: orange !important;',
          title: 'Paid Off',
          display: true
        }
      } else if (DataType.LoanTagsEnum.SP_PO_COLLECTION.value === (tags & DataType.LoanTagsEnum.SP_PO_COLLECTION.value) || DataType.LoanTagsEnum.SP_PO_COLLECTION_REJECT.value === (tags & DataType.LoanTagsEnum.SP_PO_COLLECTION_REJECT.value) || DataType.LoanTagsEnum.SP_ELSE_REJECT.value === (tags & DataType.LoanTagsEnum.SP_ELSE_REJECT.value)) {
        returningIcon = {
          style: 'sync_alt',
          color: 'color: green !important;',
          title: 'Loan Transfer',
          display: true
        }
      } else if (DataType.LoanTagsEnum.DP_GOOD_RATIO.value === (tags & DataType.LoanTagsEnum.DP_GOOD_RATIO.value) || DataType.LoanTagsEnum.DP_PO_COLLECTION.value === (tags & DataType.LoanTagsEnum.DP_PO_COLLECTION.value) || DataType.LoanTagsEnum.DP_ELSE.value === (tags & DataType.LoanTagsEnum.DP_ELSE.value)) {
        returningIcon = {
          style: 'sync_alt',
          color: 'color: orange !important;',
          title: 'Loan Transfer',
          display: true
        }
      } else if (DataType.LoanTagsEnum.SP_GOOD_REJECT.value === (tags & DataType.LoanTagsEnum.SP_GOOD_REJECT.value)) {
        returningIcon = {
          style: 'price_check',
          color: 'color: green !important;',
          title: 'Good D/C',
          display: true
        }
      } else if (DataType.LoanTagsEnum.DP_GOOD.value === (tags & DataType.LoanTagsEnum.DP_GOOD.value)) {
        returningIcon = {
          style: 'price_check',
          color: 'color: orange !important;',
          title: 'Good D/C',
          display: true
        }
      } else if (DataType.LoanTagsEnum.ROCKET_CREDIT.value === (tags & DataType.LoanTagsEnum.ROCKET_CREDIT.value)) {
        returningIcon = {
          style: 'flash_on',
          color: 'color: green !important;',
          title: 'Rocket Credit',
          display: true
        }
      }
      // endregion

      // region re-sent
      if (value.auditedBy) {
        reSentIcon = {
          style: 'published_with_changes',
          color: 'color: orange !important;',
          title: 'Re-Sent to UW',
          display: true
        }
      }
      // endregion

      // region Credit Card
      if (DataType.LoanFlagsEnum.INSTANT_FUND.value === (value.flags & DataType.LoanFlagsEnum.INSTANT_FUND.value)) {
        creditCardIcon = {
          display: true
        }
      }
      // endregion

      // region compress
      if (DataType.LoanTagsEnum.COMPRESS_SIGNATURE_LINK.value === (tags & DataType.LoanTagsEnum.COMPRESS_SIGNATURE_LINK.value)) {
        compressIcon = {
          display: true
        }
      }
      if (DataType.LoanFlagsEnum.FOX_EXPRESS.value === (flags & DataType.LoanFlagsEnum.FOX_EXPRESS.value)) {
        foxExpressIcon = {
          display: true
        }
      }
      // endregion

      value.features[0] = sameDayIcon
      if (returningIcon.display === true) {
        value.features[1] = returningIcon
      } else {
        value.features[1].title = '—'
        value.features[1].display = false
      }

      if (reSentIcon.display === true) {
        value.features[2] = reSentIcon
      } else {
        value.features[2].title = '—'
        value.features[2].display = false
      }

      if (creditCardIcon.display === true) {
        value.features[3] = creditCardIcon
      } else {
        value.features[3].title = '—'
        value.features[3].display = false
      }

      if (compressIcon.display === true) {
        value.features[4] = compressIcon
      } else {
        value.features[4].title = '—'
        value.features[4].display = false
      }
      if (foxExpressIcon.display === true) {
        value.features[5] = foxExpressIcon
      } else {
        value.features[5].title = '—'
        value.features[5].display = false
      }
    },
    getTableBackgroundColor (item) {
      if ($tool.isNotEmpty(item.features)) {
        if (item.features[0].display === true && item.loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
          return 'background-color: #DC8EFF'
        }
        if (item.features[2].display === true && item.loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
          return 'background-color: #FFF780'
        }
        if (item.features[3].display === true && item.loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
          return 'background-color: #3EBAFF'
        }
      }
    }
  }
}
</script>

<style lang="css">
  .vue-waterfall-column {
    padding-left: 10px;
  }
</style>

<style lang="scss" scoped>
.queue-header-btn {
  top:inherit;
  height: 35px;
  .topLeft {
    position:fixed;
    text-transform: capitalize;
  }
}
.language-style {
  display: inline-flex;
  align-items: center;
}
.language-dropdown {
  width:142px;
  }
.loan-work-queue {
  max-width: calc(100vw) !important;
  min-width: calc(100vw - 280px) !important;
  height: calc(100vh - 165px);
  padding-right: 0;
}
.queue-content {
  height: calc(100vh - 278px);
}
.scroll {
  height: calc(100vh - 285px);
  overflow: auto;
  width: 100%;
}
.scroll::-webkit-scrollbar {
  width: 6px;
}
.active {
  height: calc(100vh - 285px);
  overflow: auto;
  width: 100%;
}
.active::-webkit-scrollbar {
  width: 6px;
}
.active::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #C1C1C1;
}
.active::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: #F1F1F1;
  border-radius: 5px;
}
.dateRange {
  position: absolute;
  left: 142px;
  top: 15px;
}
.choose {
  color: #000 !important;
}
.v-icon {
  color: #ccc;
  font-size: 18px;
  margin-top: -2px;
}
.topRight {
  position: fixed;
  top: inherit;
  right: 0;
  color: #000;
  font-size: 28px;
  cursor: pointer;
}
.nav-tabs{
  list-style:none;
  padding: 0;
  width:auto;
  overflow: hidden;
  background: white;
  text-align: center;
  margin: -4px 0 0;
}
.nav-item {
  float: left;
  background: #fafafa;
  width: auto;
  height: 28px;
}
.nav-item a {
  height: 28px;
  font-size: 18px;
  vertical-align: 10px;
  text-decoration: none;
  padding: 5px 20px;
  color: #000;
}
.nav-item a:hover, .nav-item a.active
{
    background-color: #03a9f4;
    color: #000;
}
.elevation-1 td {
  font-size: 10px !important;
  white-space: nowrap;
}
.elevation-1 th {
  font-size: 6px !important;
}
.queue-content-table {
  height: calc(100vh - 288px);
}
.elevation-1 {
  height: calc(100vh - 298px);
}
.vue-waterfall {
  overflow: hidden;
}
.tableShow {
  width:4px;
  height: 38px;
  display: inline-block;
  border-radius: 20px;
}
.tableLoanDetails {
  display: inline-block;
  margin-left: 12px;
}
.tableLoanNo {
  color:#161A40;
  font-weight: bolder;
  font-size: 16px;
  height: 20px;
}
.tableName {
  color:#3F4360;
  font-size: 14px;
  height: 18px;
}
.tableRequestedAmount {
  color:#3F4360;
  font-weight: 500;
  font-size: 14px;
  margin-left: 8px;
  height: 18px;
}
.detailBtn {
  text-transform: none;
  color: #FFF;
  font-size: 12px;
  height: 16px;
  border-radius: 2px;
}
.locked-icon {
  margin-left: 8px;
  margin-bottom: -4px;
}
.loanFirst {
  width: 318px;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row), .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row) {
  border: none;
}
.v-tab {
  text-transform: capitalize;
}
</style>
<style>
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: var(--thColor);
  white-space: nowrap;
}
.queue-tab-card .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr {
  height: 66px;
}
.queue-tab .theme--dark.v-icon, .queue-tab-card .theme--dark.v-icon{
  color: var(--thColor);
}
.theme--light.v-data-table > .v-data-table__wrapper {
  /*
  overflow-x: hidden;
  */
}
.loan-work-queue .elevation-1 .v-data-table__wrapper {
  height: calc(100vh - 358px) !important;
}

.loan-queue-tabs .v-tab--active {
  color: var(--thColor) !important;
}
.loan-queue-tabs .v-tab--active:hover {
  background: var(--tabColor) !important;
  color: var(--thColor) !important;
}
.loan-queue-tabs .v-tab:hover {
  background: var(--tabColor) !important;
}
.loan-queue-tabs.theme--dark.v-tabs .v-tab--active:hover::before, .theme--dark.v-tabs .v-tab--active::before {
  opacity: 0;
}
.loan-queue-tabs.theme--dark.v-tabs .v-tab:hover::before {
  opacity: 0;
}
</style>
